module.exports = __webpack_public_path__ + "img/attachment.1ea2fdab.svg";